import { Component, OnDestroy } from '@angular/core';
import { LoginService, WebClient } from '@injectables';
import { Device } from '@models';
import { Subscription } from 'rxjs';
import { FragQueryService } from 'src/injectables/frag-query.service';
@Component({
    selector: 'manage',
    templateUrl: './manage.component.html',
    styleUrls: ['./manage.component.scss'],
})
export class ManageComponent implements OnDestroy {
    constructor(
        public loginService: LoginService,
        private fragQuery: FragQueryService,
        private readonly webClient: WebClient
    ) { }
    
    private subscriptions = new Subscription();

    public visibleDeviceDropDown = true
    public readonly device$ = this.fragQuery.device$;
    public isSuperAdmin = this.loginService.isUserSuperAdmin();
    public isUserClientAdmin = this.loginService.isUserClientAdmin();
    public isUserSiteAdmin = this.loginService.isUserSiteAdmin();
    public isUserMultiClientAdmin = this.loginService.isUserMultiClientAdmin;

    public ngOnInit(): void {
        this.updateRoleFlags();

        this.subscriptions.add(
            this.fragQuery.userSettingUpdated$.subscribe(() => {
                this.updateRoleFlags();
            })
        );
    }

    private updateRoleFlags() {
        this.isSuperAdmin = this.loginService.isUserSuperAdmin();
        this.isUserClientAdmin = this.loginService.isUserClientAdmin();
        this.isUserSiteAdmin = this.loginService.isUserSiteAdmin();
        this.isUserMultiClientAdmin = this.loginService.isUserMultiClientAdmin;
    }

    public saveDevice = async (device: Device) => {
        return this.webClient.model.device.save(device as Device);
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}